<template>
  <b-container>
    <b-row class="align-items-center">
      <b-col>
        <h1>Edit User</h1>
      </b-col>
      <b-col>
        <b-button class="float-right" href="/admin/users">Back to Users</b-button>
      </b-col>
    </b-row>
    <hr />
    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="First Name"
      label-for="name_first" :class="{
        'text-danger': validation.hasError('user.name_first'),
      }">
      <b-form-input id="name_first" placeholder="First Name" v-model="user.name_first"></b-form-input>
      <span class="error-message">{{
        validation.firstError("user.name_first")
      }}</span>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Last Name" label-for="name_last"
      :class="{
          'text-danger': validation.hasError('user.name_last'),
        }">
      <b-form-input id="name_last" placeholder="Last Name" v-model="user.name_last"></b-form-input>
      <span class="error-message">{{
        validation.firstError("user.name_last")
      }}</span>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Job Title" label-for="title">
      <b-form-input id="title" placeholder="Job Title" v-model="user.title"></b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Biography" label-for="bio">
      <b-form-textarea id="bio" placeholder="Biography" v-model="user.bio"></b-form-textarea>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Phone" label-for="phone" :class="{
        'text-danger': validation.hasError('user.phone'),
      }">
      <b-form-input id="phone" placeholder="Phone Number" v-model="user.phone"></b-form-input>
      <span class="error-message">{{
        validation.firstError("user.phone")
      }}</span>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Status" label-for="opt_active">
      <b-form-select v-model="user.opt_active" id="opt_active" :options="status_codes"></b-form-select>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Admin" label-for="opt_admin">
      <b-form-select v-model="user.opt_admin" id="opt_admin" :options="admin_codes"></b-form-select>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Underwriter"
      label-for="opt_underwriter">
      <b-form-select v-model="user.opt_underwriter" id="opt_underwriter" :options="underwriter_codes"></b-form-select>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Avatar" label-for="avatar">
      <b-form-select v-model="user.avatar" id="avatar" :options="avatar"></b-form-select>
    </b-form-group>

    <hr class="my-4" />

    <h3 class="mb-4 text-info">Login</h3>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Email" label-for="email" :class="{
        'text-danger': validation.hasError('user.email'),
      }">
      <b-form-input id="email" placeholder="Email" v-model="user.email"></b-form-input>
      <span class="error-message">{{
        validation.firstError("user.email")
      }}</span>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols-md="2" content-cols-md="4" label="Password" label-for="password"
      :class="{
          'text-danger': validation.hasError('user.password'),
        }">
      <b-form-input id="password" placeholder="Password" v-model="user.password"></b-form-input>
      <span class="error-message">{{
        validation.firstError("user.password")
      }}</span>
    </b-form-group>

    <hr />
    <b-alert variant="danger" :show="validation.errors.length > 0">
      There are missing required fields</b-alert>
    <b-button variant="primary" v-if="validation.errors.length === 0" @click="saveUser">Save User</b-button>
    <b-alert v-if="successMsg" variant="success" dismissible show>
      {{ successMsg }}</b-alert>
  </b-container>
</template>

<script>
import UserDataService from "@/services/UserDataService";
import ReferenceDataService from "@/services/ReferenceDataService";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;
export default {
  data() {
    return {
      user: {
        email: "",
        password: "",
        name_first: "",
        name_last: "",
        phone: "",
        opt_active: 0,
        opt_admin: 0,
        opt_underwriter: 0,
        opt_email_reminder: 0,
        avatar: "",
        title: "",
        bio: "",
      },
      status_codes: [],
      avatar: [],
      successMsg: null,
    };
  },

  validators: {
    "user.name_first": function (value) {
      return Validator.value(value).required("First name is required");
    },
    "user.name_last": function (value) {
      return Validator.value(value).required("Last name is required");
    },
    "user.phone": function (value) {
      return Validator.value(value).required("Phone number is required");
    },
    "user.email": function (value) {
      return Validator.value(value).required("Email is required");
    },
    "user.password": function (value) {
      const baseValidator = Validator.value(value);

      // Check if the password length is greater than zero
      if (value.length > 0) {
        return baseValidator
          .required("Password is required")
          .minLength(8, "Password must be at least 8 characters long")
          .regex(/[a-z]/, "Password must contain at least one lowercase letter")
          .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
          .regex(/[0-9]/, "Password must contain at least one number");
      }

      return baseValidator;

    },
  },

  created() {
    if (this.$route.params.id !== undefined) {
      UserDataService.getAdminUser(this.$route.params.id).then((res) => {
        this.user = res.data;
        this.user.password = '';
        this.action = "update";
      });
    }

    this.admin_codes = UserDataService.user_admin_codes().map((obj) => ({
      value: obj.id,
      text: obj.label,
    }));
    this.underwriter_codes = UserDataService.user_underwriter_codes().map(
      (obj) => ({
        value: obj.id,
        text: obj.label,
      })
    );
    this.status_codes = UserDataService.user_status_codes().map((obj) => ({
      value: obj.id,
      text: obj.label,
    }));
    this.avatar = ReferenceDataService.avatars();
  },

  methods: {
    async saveUser() {
      let delay;
      if (this.action === "update") {
        try {
          await UserDataService.update(this.user.id, this.user).then(() => {
            this.successMsg = "User saved successfully";
            delay = setTimeout(() => {
              this.$router.push("/admin/users");
            }, 400);
          });
        } catch (err) {
          this.$emit("error", err);
          clearTimeout(delay);
        }
      } else {
        try {
          await UserDataService.create(this.user).then(() => {
            this.successMsg = "User saved successfully";
            delay = setTimeout(() => {
              this.$router.push("/admin/users");
            }, 400);
          });
        } catch (err) {
          this.$emit("error", err);
          clearTimeout(delay);
        }
      }
    },
  },
  watch: {
    user: function () {
      this.$validate();
    },
  },
};
</script>
